<script>
  import { createEventDispatcher } from "svelte";
  import { api } from "../../services/api";
  import { closeModal } from "svelte-modals";
  

  export let userId;
  export let existing = {};
  export let onSaved = () => {};

  

  const dispatch = createEventDispatcher();

  let firstName  = existing.firstName  || "";
  let lastName   = existing.lastName   || "";
  let country    = existing.country    || "";
  let city       = existing.city       || "";
  let hospital   = existing.hospital   || "";
  let role       = existing.role       || "";
  let speciality = existing.speciality  || "";

  let saving = false;
  let errorMsg = "";

  async function save() {

    // TO BE ADDED WHEN USER WILL BE ABLE TO EDIT PROFILE //
    // const resp = await api.get(`/users/${userId}`);
    // existing = resp.data;

    saving = true;
    errorMsg = "";
    if (!firstName.trim() || !lastName.trim()) {
      errorMsg = "First name and last name are required.";
      saving=false;
      return;
    }
    try {
      // reuse POST /api/users (upsert) – it already exists
      await api.post("/api/users", {
        userId,
        firstName,
        lastName,
        country,
        city,
        hospital,
        role,
        speciality,
      });

      const updated = {
        first_name: firstName,
        last_name: lastName,
        country_code: country,
        city: city,
        hospital: hospital,
        role_code: role,
        speciality: speciality,
      };

      onSaved(updated);
      closeModal();
      dispatch("close");
    } catch (e) {
      console.error(e);
      errorMsg = "Failed to save profile, please try again.";
    } finally {
      saving = false;
    }
  }
</script>

<div class="modal">
  <div class="modal-content">
    <h2>Complete your profile</h2>

    {#if errorMsg}
      <p class="error">{errorMsg}</p>
    {/if}

    <label>First name <input bind:value={firstName} /></label>
    <label>Last name <input bind:value={lastName} /></label>
    <label>Country <input bind:value={country} /></label>
    <label>City <input bind:value={city} /></label>
    <label>Hospital <input bind:value={hospital} /></label>
    <label>Role <input bind:value={role} /></label>
    <label>Speciality <input bind:value={speciality} /></label>

    <button on:click={save} disabled={saving}>
      {saving ? "Saving..." : "Save"}
    </button>
  </div>
</div>

<style>
  .modal {
    position: fixed; inset: 0; display:flex;
    align-items:center; justify-content:center;
    background: rgba(0,0,0,0.5); z-index: 9999;
  }
  .modal-content {
    background: white; padding: 20px; border-radius: 8px; width: 320px;
    display:flex; flex-direction:column; gap:8px;
  }
  .error { color: red; }
  label { display:flex; flex-direction:column; font-size: 0.9rem; }
  input { padding:4px 6px; }
  button { margin-top:10px; padding:6px 10px; }
</style>